// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"a18cd997","549":"f834828a"}[chunkId] + ".chunk.js";
};